import { useEffect, useRef, useState } from 'react';
import { useHandleInputChange } from '../hooks/useHandleInputChange';
import { _zzsurvey_ajax } from '../utils/zz/zz-zzsurvey-ajax-adapter';
import { _zzsurvey_formDefiinitionCustomer_v2 } from '../utils/zz/zz-zzsurvey-utils';
import JSDisplayValue from "./JSDisplayValue";
import Btn from './Btn';
import SpinnerClassic from './SpinnerClassic';
import jwt from 'jsonwebtoken';
import QRCode from 'react-qr-code';
import FormGenerator from './FormGenerator';
import FormFieldGenerator from './FormFieldGenerator';


// NNN

/*
*/


//
const _create_quiz_fill_url_without_email_step_register = (token_from_qr_template) => {
  const origin = window.location.origin; // "http://localhost:3000"
  const url = origin + '/survey-qr/' + token_from_qr_template;
  // https://dev.ratemyservice.rs/survey-qr/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW1wbGF0ZV9pZCI6OCwiY2xpZW50X2lkIjoxLCJpYXQiOjE3NTI1MDA5NjZ9.h-5aYZSRwbJropB-HZSnEsK4JzGj9PVLT9Q3B_WqPmw
  return url;
};



//
const _create_quiz_fill_url = (quiz_key) => {
  const origin = window.location.origin; // "http://localhost:3000"
  const url = origin + '/survey/' + quiz_key;
  // https://dev.ratemyservice.rs/survey/67e49b2f-4ba2-4d48-b7aa-333fe94fa844
  return url;
};


// DEFAULT COMPONENT
const ZZTempQRCodeForQuizFillByQrV2 = (props) => {
  console.log('ZZTempQRCodeForQuizFillByQrV2 props', props);
  const {
    entity, // template entity
    routeSimple,
    error_msg_handle,
  } = props;

  //
  const [urlFromTemplate, setUrlFromTemplate] = useState('');
  const [urlForQuizFillWithoutEmail, setUrlForQuizFillWithoutEmail] = useState('');
  const [tokenFromTemplateURL, setTokenFromTemplateURL] = useState('');
  const [urlForQrCode, setUrlForQrCode] = useState('');

  /// const [state, handleChange, setState] = useHandleInputChange({}); // state of register user form



  //
  const _extract_token_from_template = (entity) => {
    // const url_full = window.location.href;
    const url_full = entity.templateUrl;
    const url = new URL(url_full); //
    const token_from_template_url = url.searchParams.get("token");
    console.log('token_from_template_url', token_from_template_url);
    setUrlForQrCode(_create_quiz_fill_url_without_email_step_register(token_from_template_url)); // NNN
    setTokenFromTemplateURL(token_from_template_url);
    if (typeof url_full === 'string') {
      setUrlFromTemplate(url_full);
    }
    //
    /*
    {
      "template_id": 7,
      "client_id": "1",
      "iat": 1752406642,
      "exp": 1752410242
    }
    */
    const { template_id, client_id } = jwt.decode(token_from_template_url);
    console.log('decoded:');
    console.log('template_id', template_id);
    console.log('client_id', client_id);
  };


  useEffect(() => {
    _extract_token_from_template(entity);
  }, [entity]);

  /*
  useEffect(() => {
    //
    //
    const token_from_template_url = tokenFromTemplateURL;
    if (typeof token_from_template_url === 'string' && token_from_template_url !== '') {
    }
    //
    //
  }, [tokenFromTemplateURL]);
  */


  // const qr_url = urlFromTemplate;
  // const qr_url = urlForQuizFillWithoutEmail;
  const qr_url = urlForQrCode;

  //
  return (
    <>
      <div className="zzsurvey-app">

        <div className="zzsurvey__sign-form__wrapper222">
          <div className="zzsurvey__sign-form__limiter">
            {/*<h1>Sign consent</h1>*/}
            <h1>QR code for fill survey directly without sending email</h1>
            <p>Survey internal name: <b>{entity.internal_name}</b></p>


            <div className="uu-gap-standalone-16px"></div>


            <h3>QR code</h3>
            {
              typeof qr_url && qr_url !== '' ? (
                <>
                  <p>Scan QR code from customer's mobile/tablet device...</p>
                  <div className="zzsurvey__qr-code-wrapper">
                    <QRCode value={qr_url} size={192} />
                  </div>
                  <h3>Or open QR code link manually</h3>
                  <p>QR code URL: <a target="_blank" rel="noopener noreferrer" href={qr_url}>{qr_url}</a></p>
                  <FormFieldGenerator
                    fieldDefinition={{
                      "type": "input_text",
                      "params": {
                        "readonly": true,
                        "label": "QR code URL",
                        "name": "url",
                        // "placeholder": "http://ratemyservice.rs",
                        // "w": 320
                      }
                    }}
                    value={qr_url}
                    handleChange={() => { }}
                  />
                </>
              ) : (
                <p>Something go wrong...</p>
              )
            }


            {/*
            <div className="uu-gap-standalone-16px"></div>
            <p>DEBUG:</p>
            <JSDisplayValue val={qr_url} />
            <JSDisplayValue val={entity} />
            */}

          </div>

        </div>
      </div>
    </>
  );
};
// <a target="_blank"

export default ZZTempQRCodeForQuizFillByQrV2;


/*
TEMPLATE SADRZI:
is_qr: true
templateUrl: "https://dev.ratemyservice.rs/templates?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW1wbGF0ZV9pZCI6NywiY2xpZW50X2lkIjoiMSIsImlhdCI6MTc1MjQwNjY0MiwiZXhwIjoxNzUyNDEwMjQyfQ.jxcZ0exGerXRRdEr15ksV6KTFIEv2f8GJ9Dlj2Eg828"



https://jwttoolbox.com/

DECODED:
Header
{
  "alg": "HS256",
  "typ": "JWT"
}
Payload
{
  "template_id": 7,
  "client_id": "1",
  "iat": 1752406642,
  "exp": 1752410242
}
*/
